import { Optional } from "common/utils/types";

import { IItemWithProduct, IPatient } from ".";

/** Matches orders CommonSimpleOrderSerializer */
export interface ISimpleOrder {
  id: number;
  client_id: number;
  status: OrderStatus;
  order_placed_time: string;
  display_number: string;
}

// TODO: make sure we don't surface these in the UI anywhere (hardcoded in filter options etc.)
/** Matches orders OrderStatus */
export const OrderStatus = {
  ApprovalNeeded: "APPROVAL_NEEDED",
  Approved: "APPROVED",
  Canceled: "CANCELED",
  PaymentFailed: "PAYMENT_FAILED",
  SentToVendor: "SENT_TO_VENDOR",
  Triaged: "TRIAGED",
  Shipped: "SHIPPED",
  Completed: "COMPLETED",
} as const;
export type OrderStatus = (typeof OrderStatus)[keyof typeof OrderStatus];

/** matches ChargedOrderItemCancelAction */
export const ChargedOrderItemCancelAction = {
  Refund: "REFUND",
  Credit: "CREDIT",
} as const;
export type ChargedOrderItemCancelAction =
  (typeof ChargedOrderItemCancelAction)[keyof typeof ChargedOrderItemCancelAction];

/** matches OrderItemStatus */
export const OrderItemStatus = {
  ApprovalNeeded: "APPROVAL_NEEDED",
  Approved: "APPROVED",
  ClinicCanceled: "CLINIC_CANCELED",
  ClientCanceled: "CLIENT_CANCELED",
  ClinicCanceledRefunded: "CLINIC_CANCELED_REFUNDED",
  ClinicCanceledCredited: "CLINIC_CANCELED_CREDITED",
  FailedSendToVendor: "FAILED_SEND_TO_VENDOR",
  SentToVendor: "SENT_TO_VENDOR",
  Triaged: "TRIAGED",
  VendorCanceled: "VENDOR_CANCELED",
  FullyShipped: "FULLY_SHIPPED",
  PartiallyShipped: "PARTIALLY_SHIPPED",
  Delivered: "DELIVERED",
} as const;
export type OrderItemStatus = (typeof OrderItemStatus)[keyof typeof OrderItemStatus];

/** Matches orders OrderItemModificationType */
export const OrderItemModificationType = {
  Create: "CREATE",
  Update: "UPDATE",
  Delete: "DELETE",
} as const;
export type OrderItemModificationType =
  (typeof OrderItemModificationType)[keyof typeof OrderItemModificationType];

/** Matches orders CommonOrderModificationOrderItemSerializer */
export interface OrderModificationOrderItem {
  id: number;
  item: IItemWithProduct;
  patient: IPatient;
  quantity: number;
  flavors_display: Optional<string>;
  modifications: string[];
  modification_notes: Optional<string>;
  price: number;
  unit_price: number;
}

/** Matches orders CommonOrderModificationOrderSerializer */
export interface OrderModificationOrder {
  id: number;
  order_items: OrderModificationOrderItem[];
  modifications: string[];
  modification_notes: Optional<string>;
  total: number;
  subtotal: number;
  tax: number;
  shipping: number;
  discount: number;
  client_handling_fees: number;
  client_purchasing_fee: number;
  original_prices: {
    subtotal: number;
    tax: number;
    shipping: number;
    discount: number;
    client_handling_fees: number;
    total: number;
  };
}

/** Matches orders/constants ApprovalNeededReason* */
export const ApprovalNeededReason = {
  HIGH_RISK_CLIENT: "HIGH_RISK_CLIENT",
  MISSING_PRESCRIPTION: "MISSING_PRESCRIPTION",
  CONTROLLED_SUBSTANCE: "CONTROLLED_SUBSTANCE",
} as const;
export type ApprovalNeededReason = (typeof ApprovalNeededReason)[keyof typeof ApprovalNeededReason];
